/* eslint-disable camelcase */
import axios from 'axios';
import { getEventTypeDetail } from 'services/event';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';

async function saveGiftTable(tableinfo) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/gift-table`,
    method: 'POST',
    data: tableinfo
  });
  return res.data.data;
}

async function saveThanksMessage(orderId, messageInfo) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/gift-table-order/${orderId}/thanks-message`,
    method: 'POST',
    data: messageInfo
  });
  return res.data.data;
}

async function getGiftTable(id, _, guest) {

  if(id){
    
    // console.log('getGiftTable: id: ', id,' _ ',_,' guest: ',guest)
    
    const res = await axios({
      url: `${BASE_PATH_API}/${ROOT}/gift-table/${id}?is_guest=${guest}`,
      method: 'GET'
    });
    const giftTableInfo = res.data.data;
  
    const eventTypeDetail = await getEventTypeDetail(giftTableInfo.type.id);
  
    const giftTableInfoWithRecommendationType = {
      ...giftTableInfo,
      recommendation_type: eventTypeDetail.recommendation_type
    };
  
    return giftTableInfoWithRecommendationType;
  }
}

/* actualiza al servicio los datos por id */
async function updateGiftTable(id, tableinfo) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/gift-table/${id}`,
    method: 'PATCH',
    data: tableinfo
  });
  const giftTableInfo = res.data.data;

  console.log('updateGiftTable - giftTableInfo: ',giftTableInfo)

  const eventTypeDetail = await getEventTypeDetail(giftTableInfo.type.id);

  console.log('updateGiftTable - eventTypeDetail: ',eventTypeDetail)

  const giftTableInfoWithRecommendationType = {
    ...giftTableInfo,
    recommendation_type: eventTypeDetail.recommendation_type
  };

  return giftTableInfoWithRecommendationType;
}

async function deleteProductGiftTable(tableId, product_id) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/gift-table/${tableId}/products`,
    method: 'DELETE',
    params: { product_id }
  });
  return res;
}

async function updateVariantIdGiftTable(tableId, product_id, data) {
  const res = await axios({
    url: `${BASE_PATH_API}/${ROOT}/gift-table/${tableId}/products?product_id=${product_id}`,
    method: 'PUT',
    data
  });
  return res;
}

export {
  saveGiftTable,
  getGiftTable,
  updateGiftTable,
  deleteProductGiftTable,
  saveThanksMessage,
  updateVariantIdGiftTable
};
